import FieldsetContainer from '@/components/shared/FieldsetContainer';

import ExamForm, { ExamFormFields } from './ExamForm';
import { BaseExamCoursePath } from '@/data/hook/exam/useExams';

type ExamInlineFormProps = {
  coursePath: BaseExamCoursePath;
  courseLineId: number;
  onSubmit: (data: ExamFormFields) => void;
  onCancel: () => void;
  isLoading: boolean;
};

export default function ExamInlineForm({
  coursePath,
  onSubmit,
  courseLineId,
  onCancel,
  isLoading,
}: ExamInlineFormProps) {
  return (
    <FieldsetContainer>
      <ExamForm
        coursePath={coursePath}
        courseLineId={courseLineId}
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
        variant="inline"
      />
    </FieldsetContainer>
  );
}
